module.exports = __webpack_public_path__ + "cb2aa4a977809a88f18f6ab61fef253a.png";